import { styled } from "@mui/material/styles";
import { Fab, Drawer, Paper } from "@mui/material";

const drawerWidth = 300;

export const RootContainer = styled('div')(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(3),
}));

export const ContentContainer = styled('div')({
  width: "100%",
  position: 'relative',
});

export const StyledDrawer = styled(Drawer)({
  width: drawerWidth,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: drawerWidth,
    padding: '16px',
  },
});

export const DrawerPaper = styled(Paper)(({ theme }) => ({
  width: drawerWidth,
  padding: theme.spacing(2),
}));

export const TableContainer = styled('div')(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(1),
  overflowX: 'auto',
}));

export const GoBackFab = styled(Fab)(({ theme }) => ({
  position: "fixed",
  top: theme.spacing(8),
  right: theme.spacing(2),
  zIndex: theme.zIndex.drawer - 1,
  backgroundColor: theme.palette.grey[200],
  '&:hover': {
    backgroundColor: theme.palette.grey[300],
  },
  '& .MuiSvgIcon-root': {
    color: theme.palette.text.primary,
  }
}));

export const FilterFab = styled(Fab)(({ theme }) => ({
  position: "fixed",
  top: theme.spacing(18),
  right: theme.spacing(2),
  zIndex: theme.zIndex.drawer - 1,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  }
})); 